import React from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { get } from 'lodash';

const assetStyle = css`
  background-color: #eeeeee;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`;

const loadingAssetStyle = css`
  width: 100%;
  height: 100%;
`;

const Asset = (props) => {
  const productBpc = get(props, 'productBpc', '');
  const className = get(props, 'className', null);
  const loading = get(props, 'loading', false);
  const assetUrl = `https://images.albertsons-media.com/is/image/ABS/${productBpc}?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available`;

  return (
    <div
      aria-label="Product graphic"
      aria-roledescription="icon"
      tabIndex={0}
      className={`asset ${loading ? loadingAssetStyle : assetStyle} ${className}`}
      style={{ backgroundImage: loading ? undefined : `url(${assetUrl})` }}
    />
  );
};

Asset.propTypes = {
  productBpc: PropTypes.string.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default Asset;
